export default "__VITE_ASSET__23661be7__"